import { MessageEnum } from '@/modules/core/models/enums'
import type ModalButton from './ModalButton'

export default class Message {
  private _type!: string
  private _title!: string
  private _label!: string
  private _button!: string
  private _extra?: { [key: string]: any } | null
  buttons: ModalButton[] = []

  constructor(data: Partial<Message> = {}) {
    this.type = data.type || MessageEnum.INFO
    this.title = data.title || ''
    this.label = data.label || ''
    this.extra = data.extra || null
    this.buttons = data.buttons || []
  }

  get title(): string {
    return this._title
  }
  set title(value: string) {
    this._title = value
  }

  get label(): string {
    return this._label
  }
  set label(value: string) {
    this._label = value
  }

  get button(): string {
    return this._button
  }
  set button(value: string) {
    this._button = value
  }

  get type(): string {
    return this._type
  }
  set type(value: string) {
    this._type = value
  }

  get extra(): { [key: string]: any } | null {
    return this._extra || null
  }

  set extra(value: { [key: string]: any } | null) {
    this._extra = value
  }
}
